import { MutationTree } from "vuex";

import { AppEventState } from "@/models/AppEventState";
import Vue from 'vue';
import { getDefaultState } from './index';

export const mutations: MutationTree<AppEventState> = {
    setEventData(state: AppEventState, eventData: AppEventState) {
        Vue.set(state, 'id', eventData.id);
        Vue.set(state, 'title', eventData.title);
        Vue.set(state, 'code', eventData.code);
        Vue.set(state, 'startDate', eventData.startDate);
        Vue.set(state, 'endDate', eventData.endDate);
        Vue.set(state, 'domains', eventData.domains);
    },
    resetEventState(state: AppEventState) {
        Object.assign(state, getDefaultState());
    }
};
